import { CEILINGS_CDN_PATH, CEILINGS_LANDING_NAME } from '../../../ceilings-constants';

export type MountingTypeGalleryStructure = {
  src: string;
  srcSmall: string;
  srcThumb: string;
  name: string;
  alt: string;
};

export const MOUNTING_TYPE_GALLERY_LIST: MountingTypeGalleryStructure[] = [
  {
    src: `${CEILINGS_LANDING_NAME}/mounting-type-gallery-popup/1.jpg/1.jpg`,
    srcSmall: `${CEILINGS_CDN_PATH}/mounting-type-gallery/01.jpg/01.jpg`,
    srcThumb: `${CEILINGS_CDN_PATH}/mounting-type-gallery-popup-thumb/1.jpg/1.jpg`,
    alt: 'Скрытый карниз',
    name: '1.jpg',
  },
  {
    src: `${CEILINGS_LANDING_NAME}/mounting-type-gallery-popup/2.jpg/2.jpg`,
    srcSmall: `${CEILINGS_CDN_PATH}/mounting-type-gallery/02.jpg/02.jpg`,
    srcThumb: `${CEILINGS_CDN_PATH}/mounting-type-gallery-popup-thumb/2.jpg/2.jpg`,
    alt: 'Скрытый карниз',
    name: '2.jpg',
  },
  {
    src: `${CEILINGS_LANDING_NAME}/mounting-type-gallery-popup/4.jpg/4.jpg`,
    srcSmall: `${CEILINGS_CDN_PATH}/mounting-type-gallery/04.jpg/04.jpg`,
    srcThumb: `${CEILINGS_CDN_PATH}/mounting-type-gallery-popup-thumb/4.jpg/4.jpg`,
    alt: 'Скрытый карниз',
    name: '4.jpg',
  },
  {
    src: `${CEILINGS_LANDING_NAME}/mounting-type-gallery-popup/5.jpg/5.jpg`,
    srcSmall: `${CEILINGS_CDN_PATH}/mounting-type-gallery/05.jpg/05.jpg`,
    srcThumb: `${CEILINGS_CDN_PATH}/mounting-type-gallery-popup-thumb/5.jpg/5.jpg`,
    alt: 'Скрытый карниз',
    name: '5.jpg',
  },
  {
    src: `${CEILINGS_LANDING_NAME}/mounting-type-gallery-popup/6.jpg/6.jpg`,
    srcSmall: `${CEILINGS_CDN_PATH}/mounting-type-gallery/06.jpg/06.jpg`,
    srcThumb: `${CEILINGS_CDN_PATH}/mounting-type-gallery-popup-thumb/6.jpg/6.jpg`,
    alt: 'Скрытый карниз',
    name: '6.jpg',
  },
  {
    src: `${CEILINGS_LANDING_NAME}/mounting-type-gallery-popup/7.jpg/7.jpg`,
    srcSmall: `${CEILINGS_CDN_PATH}/mounting-type-gallery/07.jpg/07.jpg`,
    srcThumb: `${CEILINGS_CDN_PATH}/mounting-type-gallery-popup-thumb/7.jpg/7.jpg`,
    alt: 'Скрытый карниз',
    name: '7.jpg',
  },
  {
    src: `${CEILINGS_LANDING_NAME}/mounting-type-gallery-popup/8.jpg/8.jpg`,
    srcSmall: `${CEILINGS_CDN_PATH}/mounting-type-gallery/08.jpg/08.jpg`,
    srcThumb: `${CEILINGS_CDN_PATH}/mounting-type-gallery-popup-thumb/8.jpg/8.jpg`,
    alt: 'Скрытый карниз',
    name: '8.jpg',
  },
  {
    src: `${CEILINGS_LANDING_NAME}/mounting-type-gallery-popup/10.jpg/10.jpg`,
    srcSmall: `${CEILINGS_CDN_PATH}/mounting-type-gallery/010.jpg/010.jpg`,
    srcThumb: `${CEILINGS_CDN_PATH}/mounting-type-gallery-popup-thumb/10.jpg/10.jpg`,
    alt: 'Скрытый карниз',
    name: '10.jpg',
  },
  {
    src: `${CEILINGS_LANDING_NAME}/mounting-type-gallery-popup/11.jpg/11.jpg`,
    srcSmall: `${CEILINGS_CDN_PATH}/mounting-type-gallery/011.jpg/011.jpg`,
    srcThumb: `${CEILINGS_CDN_PATH}/mounting-type-gallery-popup-thumb/11.jpg/11.jpg`,
    alt: 'Скрытый карниз',
    name: '11.jpg',
  },
  {
    src: `${CEILINGS_LANDING_NAME}/mounting-type-gallery-popup/13.jpg/13.jpg`,
    srcSmall: `${CEILINGS_CDN_PATH}/mounting-type-gallery/013.jpg/013.jpg`,
    srcThumb: `${CEILINGS_CDN_PATH}/mounting-type-gallery-popup-thumb/13.jpg/13.jpg`,
    alt: 'Скрытый карниз',
    name: '13.jpg',
  },
  {
    src: `${CEILINGS_LANDING_NAME}/mounting-type-gallery-popup/14.jpg/14.jpg`,
    srcSmall: `${CEILINGS_CDN_PATH}/mounting-type-gallery/014.jpg/014.jpg`,
    srcThumb: `${CEILINGS_CDN_PATH}/mounting-type-gallery-popup-thumb/14.jpg/14.jpg`,
    alt: 'Скрытый карниз',
    name: '14.jpg',
  },
  {
    src: `${CEILINGS_LANDING_NAME}/mounting-type-gallery-popup/15.jpg/15.jpg`,
    srcSmall: `${CEILINGS_CDN_PATH}/mounting-type-gallery/015.jpg/015.jpg`,
    srcThumb: `${CEILINGS_CDN_PATH}/mounting-type-gallery-popup-thumb/15.jpg/15.jpg`,
    alt: 'Скрытый карниз',
    name: '15.jpg',
  },
  {
    src: `${CEILINGS_LANDING_NAME}/mounting-type-gallery-popup/17.jpg/17.jpg`,
    srcSmall: `${CEILINGS_CDN_PATH}/mounting-type-gallery/017.jpg/017.jpg`,
    srcThumb: `${CEILINGS_CDN_PATH}/mounting-type-gallery-popup-thumb/17.jpg/17.jpg`,
    alt: 'Скрытый карниз',
    name: '17.jpg',
  },
];
